export default __webpack_public_path__ + "6ed680ba0c130421edec642d2a6bf885.png";